
import React from 'react';
import { Tag } from 'antd';

export const renderWeddingCanvaStatus = (statusKey, statusTrans) => {
    switch (statusKey) {
        case "IN_PROGRESS":
            return <Tag color="yellow">{statusTrans}</Tag>;
        case "SUBMITTED":
            return <Tag color="green">{statusTrans}</Tag>;
        case "APPROVED":
            return <Tag color="blue">{statusTrans}</Tag>;
        case "DELETED":
            return <Tag color="red">{statusTrans}</Tag>;
    }
}